import { HStack as ChakraHStack } from "@chakra-ui/react";
import { type StackProps } from "./Stack.web";

export default function HStack({
  spacing,
  gap,
  ...props
}: StackProps): JSX.Element {
  // In Chakra v3, 'spacing' is replaced by 'gap'
  // We maintain backward compatibility by accepting 'spacing' and mapping it to 'gap'
  const gapValue = gap !== undefined ? gap : spacing;

  return <ChakraHStack gap={gapValue} {...props} />;
}
